import { Injectable, inject } from '@angular/core';
import { FeatureFlagService } from '@feature-flag';
import { catchError, of, take } from 'rxjs';

import { ToasterService } from '#shared/components/toaster/toaster.service';

import { getDisablePostForFlags } from './disable-post-for.config';

@Injectable({
  providedIn: 'root',
})
export class DisablePostForToastService {
  private readonly featureFlagService = inject(FeatureFlagService);
  private readonly toasterService = inject(ToasterService);

  constructor() {
    this.checkFlags();
  }

  private checkFlags(): void {
    for (const entry of getDisablePostForFlags()) {
      this.featureFlagService
        .getFlagValue(entry.flagName)
        .pipe(
          take(1),
          catchError(() => of(false)),
        )
        .subscribe((isDisabled) => {
          if (isDisabled) {
            this.toasterService.showWarning(entry.toastMessage, entry.flagName);
          }
        });
    }
  }
}
